export enum Role {
  Admin = 'ADMIN',
  Leader = 'LEADER',
  Manager = 'MANAGER',
  ViewerMember = 'VIEWER_MEMBER',
  Member = 'MEMBER',
  Unknown = 'UNKNOWN'
}

const RoleLevels = {
  [Role.Admin]: 5,
  [Role.Leader]: 4,
  [Role.Manager]: 3,
  [Role.ViewerMember]: 2,
  [Role.Member]: 1,
  [Role.Unknown]: 0
}

export const isHigherRole = (role1: Role, role2: Role): boolean =>
  RoleLevels[role1] >= RoleLevels[role2]
export const getRoleFromString = (roleString: string): Role =>
  Object.values(Role).includes(roleString as Role) ? (roleString as Role) : Role.Unknown
export const selectableRoles = Object.values(Role).filter((role) => role !== Role.Unknown)
